// extracted by mini-css-extract-plugin
export default {"videoBackground":"Umra_videoBackground__48C5U"};